var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3180_8683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.334 6.99967H20.7906C20.919 6.63801 21.0007 6.24134 21.0007 5.83301C21.0007 3.89634 19.4373 2.33301 17.5007 2.33301C16.2757 2.33301 15.214 2.96301 14.584 3.90801L14.0007 4.68967L13.4173 3.89634C12.7873 2.96301 11.7257 2.33301 10.5007 2.33301C8.56398 2.33301 7.00065 3.89634 7.00065 5.83301C7.00065 6.24134 7.08232 6.63801 7.21065 6.99967H4.66732C3.37232 6.99967 2.34565 8.03801 2.34565 9.33301L2.33398 22.1663C2.33398 23.4613 3.37232 24.4997 4.66732 24.4997H23.334C24.629 24.4997 25.6673 23.4613 25.6673 22.1663V9.33301C25.6673 8.03801 24.629 6.99967 23.334 6.99967ZM17.5007 4.66634C18.1423 4.66634 18.6673 5.19134 18.6673 5.83301C18.6673 6.47467 18.1423 6.99967 17.5007 6.99967C16.859 6.99967 16.334 6.47467 16.334 5.83301C16.334 5.19134 16.859 4.66634 17.5007 4.66634ZM10.5007 4.66634C11.1423 4.66634 11.6673 5.19134 11.6673 5.83301C11.6673 6.47467 11.1423 6.99967 10.5007 6.99967C9.85898 6.99967 9.33398 6.47467 9.33398 5.83301C9.33398 5.19134 9.85898 4.66634 10.5007 4.66634ZM23.334 22.1663H4.66732V19.833H23.334V22.1663ZM23.334 16.333H4.66732V9.33301H10.594L8.16732 12.6347L10.0573 13.9997L12.834 10.2197L14.0007 8.63301L15.1673 10.2197L17.944 13.9997L19.834 12.6347L17.4073 9.33301H23.334V16.333Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3180_8683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrize);
export default __webpack_public_path__ + "static/media/prize.e8aa23b2af8c2425c71c4527c765d1f3.svg";
export { ForwardRef as ReactComponent };